var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ListItem as MuiListItem } from '@mui/material';
import Text from '../../../Text';
import colors from '../../../../themes/colors';
export default function AccountMenuListItem(_a) {
    var item = _a.item, isActive = _a.isActive;
    return (_jsx(MuiListItem, __assign({ onClick: item.onClick, sx: {
            borderRadius: '4px',
            cursor: item.onClick ? 'pointer' : 'default',
            backgroundColor: isActive ? colors.neutral5 : 'transparent',
            transition: 'background-color 0.2s ease-in-out',
            '&:hover': {
                backgroundColor: colors.neutral0
            },
            '& p': {
                fontWeight: isActive ? '600' : '400'
            }
        } }, { children: _jsx(Text, __assign({ variant: "body2", color: isActive ? 'neutral100' : 'neutral80' }, { children: item.label })) })));
}
